import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("ef_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me")
            .then((r) => setUser(r.data.user))
            .catch(() => localStorage.removeItem("ef_token"))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("ef_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password, ref) => {
        const payload = { name, email, password };
        if (ref) payload.ref = ref;
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("ef_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("ef_token");
        setUser(null);
    };

    const refreshUser = async () => {
        const r = await api.get("/auth/me");
        setUser(r.data.user);
        return r.data.user;
    };

    return (
        <AuthContext.Provider value={{ user, login, register, logout, loading, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
